const VALID_LINK_TARGETS = new Set(['none', 'google', 'custom']);
const ALL_LOCATIONS_GROUP_KEYS = new Set(['all', 'default', 'none']);

export const isAllLocationsGroupKey = (value) => {
    const normalized = String(value || '').trim().toLowerCase();
    return ALL_LOCATIONS_GROUP_KEYS.has(normalized);
};

export const normalizeLinkTarget = (configuredLinkTarget, legacyLinkEnabled = true) => {
    const normalized = String(configuredLinkTarget || '').trim().toLowerCase();
    if (VALID_LINK_TARGETS.has(normalized)) {
        return normalized;
    }
    return legacyLinkEnabled ? 'google' : 'none';
};

const getSourceReviewGroups = (source) => {
    const groups = source?.reviewGroups ?? source?.ReviewGroups;
    if (!Array.isArray(groups)) {
        return [];
    }
    return groups
        .map(group => String(group || '').trim())
        .filter(Boolean);
};

export const countSourcesForGroup = (sources, groupKey) => {
    if (!Array.isArray(sources)) {
        return null;
    }

    const normalizedGroupKey = String(groupKey || '').trim().toLowerCase();
    if (!normalizedGroupKey) {
        return 0;
    }

    if (isAllLocationsGroupKey(normalizedGroupKey)) {
        return sources.length;
    }

    return sources.reduce((count, source) => {
        const hasGroup = getSourceReviewGroups(source)
            .some(group => group.toLowerCase() === normalizedGroupKey);
        return hasGroup ? count + 1 : count;
    }, 0);
};

export const resolveReviewsLinkAction = ({
    configuredLinkTarget,
    legacyLinkEnabled = true,
    selectionCount,
    isAllLocationsGroup = false
} = {}) => {
    const resolvedLinkTarget = normalizeLinkTarget(configuredLinkTarget, legacyLinkEnabled);
    const parsedCount = Number(selectionCount);
    const hasKnownCount = Number.isFinite(parsedCount);
    // Allow "all/default" groups when there is exactly one source selected.
    const isSingleSourceSelection = hasKnownCount && parsedCount === 1;
    const isGoogleEligible = isSingleSourceSelection && (!isAllLocationsGroup || isSingleSourceSelection);
    const availableActions = isGoogleEligible
        ? ['google', 'custom', 'none']
        : ['custom', 'none'];
    const nextLinkTarget = resolvedLinkTarget === 'google' && !isGoogleEligible
        ? 'none'
        : resolvedLinkTarget;

    return {
        availableActions,
        isGoogleEligible,
        nextLinkTarget
    };
};
